// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_Dt_","cls2":"Comments-cls2_C1A Comments-cls1_Dt_"};